import { Popover as MuiPopover, type PopoverProps } from '@mui/material';

export const Popover = (props: PopoverProps) => <MuiPopover {...props} />;
